import { useCallback } from 'react'
import { deleteScenario } from 'src/redux/slices/project/endpoints'

import IconButton from '@material-ui/core/IconButton'
import CancelIcon from '@material-ui/icons/Cancel'

///// Types
type DeleteScenarioProps = {
  id: number
  disabled: boolean
}

///// Component
const DeleteScenario: React.FC<DeleteScenarioProps> = ({ id, disabled }) => {
  const [trigger, { data, isLoading }] = deleteScenario.useMutation({
    fixedCacheKey: 'deleteScenario',
  })

  const submit = useCallback(() => {
    trigger(id)
  }, [trigger])
  return (
    <IconButton size='small' onClick={submit} disabled={disabled}>
      <CancelIcon />
    </IconButton>
  )
}
export default DeleteScenario
